import {
  type GenerateStyle,
  type FullToken,
  genComponentStyleHook,
} from "antd/es/theme/internal";
import { tablePrefixCls } from "@/base/components/table/Table.component";
import { spinPrefixCls } from "@/base/index";
import { THEME_PREFIX } from "@/base/constant";

const genStyle: GenerateStyle<FullToken<"Table">> = ({
  expandColorIcon,
  expandSizeIcon,
  footerBg, //fontWeightStrong
}: any) => ({
  [`.${THEME_PREFIX}`]: {
    [`&.${tablePrefixCls}-wrapper`]: {
      [`.${spinPrefixCls}`]: {
        // backgroundColor: `${colorBgSpin} !important`,

        [`.${spinPrefixCls}-dot`]: {
          fontSize: `80px`,
        },
      },
    },
    [`.${tablePrefixCls}`]: {
      [`.${tablePrefixCls}-column-sorters, .${tablePrefixCls}-filter-column`]: {
        justifyContent: "normal",
        display: "inline-flex",
        [`.${tablePrefixCls}-column-title`]: {
          flex: "initial",
          wordBreak: "break-word",
        },
      },
      [`.${tablePrefixCls}-column-sorter-inner`]: {
        [`& > *:not(.active)`]: {
          display: "none",
        },
        [`& > *`]: {
          marginTop: 0,
        },
      },
      [`.${tablePrefixCls}-container`]: {
        borderColor: "transparent !important",
      },
      [`.${tablePrefixCls}-expand-icon`]: {
        color: expandColorIcon,
        fontSize: `${expandSizeIcon}px`,
        marginRight: "4px",
        cursor: "pointer",
      },
      [`.${tablePrefixCls}-tbody`]: {
        [`.${tablePrefixCls}-cell:not(.cso-table-cell-fix-left-last)`]: {
          borderRightColor: "transparent !important",
        },
      },
      [`.${tablePrefixCls}-summary`]: {
        [`.${tablePrefixCls}-cell`]: {
          backgroundColor: footerBg,
          // fontWeight: fontWeightStrong,

          [`&:not(.cso-table-cell-fix-left-last)`]: {
            borderRightColor: "transparent !important",
          },
        },
      },
      [`.${tablePrefixCls}-thead`]: {
        [`.${tablePrefixCls}-cell`]: {
          [`&:not(.${tablePrefixCls}-column-sort) .${tablePrefixCls}-column-sorter`]:
            {
              display: "none",
            },
          [`&:last-child`]: {
            borderRightColor: "transparent !important",
          },
        },
      },
    },
  },
});

export const useTableStyle = genComponentStyleHook(
  ["Table", "cso"],
  (token) => {
    return [genStyle(token)];
  },
);
